var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options
    ? _c(
        "div",
        { staticClass: "full-view-select" },
        [
          _c(
            "div",
            {
              staticClass: "main-option-container",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleOptions.apply(null, arguments)
                }
              }
            },
            [
              _c("span", { staticClass: "main-option" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      (_vm.optionSelected &&
                        _vm.optionSelected[_vm.optionTextField]) ||
                        "Sort By" ||
                        "Select an option"
                    ) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade-fast" } }, [
            _vm.showOptions
              ? _c("div", { staticClass: "full-view-options-container" }, [
                  _c("a", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.close.apply(null, arguments)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "full-view-options" },
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "full-view-option",
                          class: { active: index === _vm.optionSelectedIndex },
                          on: {
                            click: function($event) {
                              return _vm.handleOptionSelected(index, option)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(option[_vm.optionTextField]) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f1257aa", { render: render, staticRenderFns: staticRenderFns })
  }
}